import { isEqual, reduce } from 'lodash'

function trainerMustDefaultPreset() {
  return {
    fh_start_spot: 'flop',
    fh_trainer_mode: 'stop_end_of_hand',
    fh_trainer_grouping: 'swv_grouping_none',
    fh_trainer_game_mode: 'trainer_actions',
    fh_trainer_game_speed: 'normal',
    fh_trainer_tables: '1',
    fh_groups_selection: 'manual',
  }
}

function trainerOptionalDefaultPreset() {
  return {
    fh_trainer_quick_result: 'on',
    fh_trainer_rng_visible: 'on',
    fh_trainer_streak_visible: 'on',
    fh_trainer_hero_range: 'on',
    fh_trainer_opponent_range: 'on',
    fh_trainer_equity_chart: 'on',
    fh_trainer_ranges_comparison: 'on',
    fh_trainer_hand_strength: 'on',
    fh_trainer_total_frequency: 'on',
    fh_trainer_category_hands: 'on',
    fh_trainer_category_draws: 'on',
    fh_trainer_hero_strategy: 'on',
    fh_groups:
      '22,33,44,55,66,77,88,99,AA,KK,QQ,JJ,TT,AKs,AKo,AQs,AJs,AQo,KQs,ATs,AJo,KJs,KQo,QJs,KTs,A9s,ATo,QTs,A8s,JTs,A7s,A5s,KJo,K9s,A4s,A6s,Q9s,A3s,T9s,QJo,J9s,A2s,KTo,A9o,K8s,QTo,K7s,JTo,Q8s,K6s,T8s,A8o,J8s,K5s,98s,A5o,A7o,K4s,K9o,Q7s,K3s,Q6s,A4o,T7s,A6o,K2s,J7s,Q9o,T9o,Q5s,97s,A3o,J9o,87s,Q4s,Q3s,A2o,K8o,76s,Q2s,J6s,T6s,J5s,65s,96s,86s,54s,K7o,J4s,Q8o,T8o,J3s,J8o,K6o,75s,98o,J2s,T5s,K5o,T4s,64s,53s,85s,95s,T3s,K4o,T2s,43s,Q7o,74s,K3o,Q6o,T7o,J7o,97o,63s,87o,K2o,52s,Q5o,93s,84s,94s,42s,92s,Q4o,32s,73s,76o,Q3o,65o,54o,86o,T6o,Q2o,J6o,96o,62s,J5o,83s,82s,J4o,75o,J3o,72s,64o,53o,J2o,85o,T5o,95o,T4o,43o,T3o,T2o,74o,63o,52o,42o,84o,93o,94o,92o,32o,73o,62o,82o,83o,72o',
  }
}

function trainerDefaultPreset() {
  return {
    ...trainerMustDefaultPreset(),
    ...trainerOptionalDefaultPreset(),
  }
}

function getTrainerClearQuery(query) {
  const qStartStreet = {
    fh_hero: '',
    fh_actions: '',
  }
  const qCustomSpot = {
    history_spot: '',
    flop_actions: '',
    preflop_actions: '',
    river_actions: '',
    turn_actions: '',
  }
  const qCommon = {
    ...trainerMustDefaultPreset(),

    // must-haves overided if present
    // fh_start_spot: 'flop',
    // fh_trainer_mode: 'stop_end_of_hand',
    // fh_trainer_grouping: 'swv_grouping_none',
    // fh_trainer_game_mode: 'trainer_actions',
    // fh_trainer_game_speed: 'normal',
    // fh_trainer_tables: '1',
    // fh_groups_selection: 'manual',

    board: '',

    gametype: '',
    depth: '',
    stacks: '',

    custree_id: '',
    // cussol_id: '',
    solution_type: 'gwiz',

    depth_list: '',
    stacks_list: '',
    average_stack: '',

    gmff_stacks_type: '',

    gmff_opening_type: '',
    gmff_tournament_phase: '',
    gmff_players: '',
    gmff_variant: '',
    gmff_cash_drop: '',

    gmff_biggest_stack: '',
    gmff_depth: '',
    gmff_type: '',
    gmff_rake: '',
    gmff_opening_size: '',
    gmff__3bet_size: '',
    gmff_simplified_position: '',
    // gmff_favorite: '', // excluded from saved drills cos when you chage your favorites drills would be not recognized

    fh_hero_stack_type: '',
    fh_opponent: '',
    fh_alternate: '',
    fh_rel_positions: '',
    fh_groups:
      '22,33,44,55,66,77,88,99,AA,KK,QQ,JJ,TT,AKs,AKo,AQs,AJs,AQo,KQs,ATs,AJo,KJs,KQo,QJs,KTs,A9s,ATo,QTs,A8s,JTs,A7s,A5s,KJo,K9s,A4s,A6s,Q9s,A3s,T9s,QJo,J9s,A2s,KTo,A9o,K8s,QTo,K7s,JTo,Q8s,K6s,T8s,A8o,J8s,K5s,98s,A5o,A7o,K4s,K9o,Q7s,K3s,Q6s,A4o,T7s,A6o,K2s,J7s,Q9o,T9o,Q5s,97s,A3o,J9o,87s,Q4s,Q3s,A2o,K8o,76s,Q2s,J6s,T6s,J5s,65s,96s,86s,54s,K7o,J4s,Q8o,T8o,J3s,J8o,K6o,75s,98o,J2s,T5s,K5o,T4s,64s,53s,85s,95s,T3s,K4o,T2s,43s,Q7o,74s,K3o,Q6o,T7o,J7o,97o,63s,87o,K2o,52s,Q5o,93s,84s,94s,42s,92s,Q4o,32s,73s,76o,Q3o,65o,54o,86o,T6o,Q2o,J6o,96o,62s,J5o,83s,82s,J4o,75o,J3o,72s,64o,53o,J2o,85o,T5o,95o,T4o,43o,T3o,T2o,74o,63o,52o,42o,84o,93o,94o,92o,32o,73o,62o,82o,83o,72o',
    // fh_groups_selection: 'manual', // must-have
    fh_hands: '',
    fh_draws: '',

    fh_trainer_result: '',
    fh_trainer_result_chart: '',
    fh_trainer_autoplay: '',
    fh_trainer_timebank: '',
    fh_trainer_hero_frequency: '',
    fh_trainer_quick_result: '',
    fh_trainer_learning_mode: '',
    fh_trainer_hero_range: '',
    fh_trainer_equity_chart: '',
    fh_trainer_opponent_range: '',
    fh_trainer_ranges_comparison: '',
    fh_trainer_hand_strength: '',
    fh_trainer_total_frequency: '',
    fh_trainer_category_hands: '',
    fh_trainer_category_draws: '',
    fh_trainer_hero_strategy: '',
    fh_trainer_rng_visible: '',
    fh_trainer_streak_visible: '',
    // fh_trainer_sounds: '',
    fh_rng: '',
    fh_trainer_session: '',

    flop_suits: '',
    flop_paired: '',
    flop_connectedness: '',
    flop_subset: '',
    flop_high_card: '',
    flop_mid_card: '',
    flop_low_card: '',
    turn_suit: '',
    turn_paired: '',
    turn_card: '',
    river_suit: '',
    river_paired: '',
    river_card: '',
  }

  let base = null
  const res = {}
  const startSpot = query.fh_start_spot
  if (startSpot === 'custom_spot') {
    base = {
      ...qCustomSpot,
      ...qCommon,
    }
  } else {
    base = {
      ...qStartStreet,
      ...qCommon,
    }
  }
  Object.keys(base).forEach(k => {
    res[k] = query[k] || base[k]
  })
  return res
}
function findDrill({ query, drills }) {
  const fullQuery = getTrainerClearQuery(query)
  const drill = drills.find(j => {
    // const clearQuery = getTrainerClearQuery(j.query)
    const drillQuery = j.query
    const match = isEqual(drillQuery, fullQuery)
    // if (j.id === 'ed9cc449-1577-4b54-8832-8806f5feedd2') { // full
    // if (j.id === '74ae006e-00eb-49f7-9a88-3a050a4422b8') { // empty
    // if (j.name.includes('preflop-husng')) {
    //   const diffs = reduce(
    //     drillQuery,
    //     (a, b, key) => {
    //       if (b !== fullQuery[key]) {
    //         // console.log(b, fullSettings[key])
    //         return [...a, key]
    //       }
    //       return a
    //     },
    //     [],
    //   )
    //   console.log('drillQuery', drillQuery)
    //   console.log('query', query)
    //   console.log('fullQuery', fullQuery)
    //   console.log('diffs', diffs)
    //   console.log('match', match)
    //   debugger
    // }
    return match
  })
  return { drill, fullQuery }
}

export {
  // trainerPresets,
  trainerOptionalDefaultPreset,
  trainerMustDefaultPreset,
  trainerDefaultPreset,
  getTrainerClearQuery,
  findDrill,
}
